import {get, post} from "@/services/api";

const state = {
    consent: {
        id: null,
        user: '',
        uisId: '',
        hasAccepted: null,
        changedAt: '',
        web: ''
    }
};

const getters = {
    consent: state => state.consent,
};

const actions = {
    async getMyConsent({commit}) {
        const response = await get('gamification/consent/');
        commit('setConsent', response.data.content);
    },
    async saveConsent({commit}, data){
        const response = await post('gamification/consent/', data)
        commit('setConsent', response.data.content);
    },
    clear({commit}){
        const clearConsent = { id: null, user: '', uisId: '', hasAccepted: null, changedAt: '', web: ''}
        commit('setConsent', clearConsent)
    }
};

const mutations = {
    setConsent: (state, con) => (Object.assign(state.consent, con)),
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}